/**
 * Ties a Zoho sign-in to the browser tab that started it, without a cookie having to survive the trip to Zoho.
 * The random verifier stays in this tab's storage; only its SHA-256 (the challenge) goes to the server, which
 * hands back a ticket that is useless without the verifier.
 */
const KEY = "zoho_verifier";

const hex = (bytes: Uint8Array) =>
  Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");

export async function startZohoSignIn(
  loginUrl: string,
  navigate: (url: string) => void = (url) => window.location.assign(url),
) {
  const verifier = hex(crypto.getRandomValues(new Uint8Array(32)));
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier));
  try {
    sessionStorage.setItem(KEY, verifier);
  } catch {
    // Storage blocked: the sign-in cannot be completed in this browser, and finishing will say so.
  }
  navigate(`${loginUrl}?challenge=${hex(new Uint8Array(digest))}`);
}

export function takeZohoVerifier(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function forgetZohoVerifier() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // nothing to forget
  }
}
